import { render, staticRenderFns } from "./RappersSlider.vue?vue&type=template&id=51fa394f&lang=pug&"
import script from "./RappersSlider.vue?vue&type=script&lang=js&"
export * from "./RappersSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports